module.exports = __webpack_public_path__ + "static/media/-_Learning Management.ae1fc58a.png";